import { render } from "./IconComponent.vue?vue&type=template&id=5ec38e38&ts=true"
import script from "./IconComponent.vue?vue&type=script&lang=ts"
export * from "./IconComponent.vue?vue&type=script&lang=ts"

import "./IconComponent.vue?vue&type=style&index=0&id=5ec38e38&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__